const NODE_ENV_ENUM = {
  PRODUCTION: "production",
  DEVELOPMENT: "development",
  STAGING: "staging",
};

export { NODE_ENV_ENUM };
